<template>
	<div>
		<li v-if="user.expiry > $page.props.dateToday" class="nav-main-item">
			<a
				class="nav-main-link"
				:class="{ active: $page.component === 'Member/Home' }"
				:href="route('member.home')"
				data-bs-placement="bottom"
				title="Go back to TRC Home"
			>
				<i class="nav-main-link-icon fa fa-arrow-left"></i>
				<span class="nav-main-link-name">TRC Home</span>
			</a>
		</li>
		<li class="nav-main-heading">TRC Community</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:href="route('member.community.home')"
				:class="{ active: $page.component === 'Member/Community' }"
			>
				<i class="nav-main-link-icon fa fa-home"></i>
				<span class="nav-main-link-name">Home</span>
			</inertia-link>
		</li>
		<li class="dropdown-divider"></li>
		<li class="nav-main-item" :class="{'open':communitiesVisited!=null}">
			<a
				class="nav-main-link nav-main-link-submenu"
				data-toggle="submenu"
				:aria-haspopup="true"
				:aria-expanded="false"
				href="#"
			>
				<span class="nav-main-link-name">RECENT</span>
			</a>
			<ul class="nav-main-submenu ps-4">
				<li
					v-for="(visited,vIndex) in communitiesVisited"
					key="submenu_1"
					class="nav-main-item"
				>
					<inertia-link
						class="nav-main-link submenu"
						:href="route('member.community.community-home',{community_name: visited.community_name})"
					>
						<img
							class="img-avatar img-avatar20 me-1 user-avatar"
							:src="(visited.icon_logo==null ? 'https://ui-avatars.com/api/?size=128&background=000000&color=FFFFFF&rounded=true&font-size=0.7&uppercase=false&length=2&name=c/' : visited.icon_logo)"
						/>
						<span class="nav-main-link-name">c/{{visited.community_name}}</span>
					</inertia-link>
				</li>
			</ul>
		</li>
		<li class="dropdown-divider"></li>
		<li class="nav-main-item open">
			<a
				class="nav-main-link nav-main-link-submenu"
				data-toggle="submenu"
				:aria-haspopup="true"
				:aria-expanded="false"
				href="#"
			>
				<span class="nav-main-link-name">COMMUNITIES</span>
			</a>
			<ul class="nav-main-submenu ps-4">
				<li
					key="submenu_1"
					class="nav-main-item"
				>
					<inertia-link class="nav-main-link submenu" href="/member/community/create">
						<i class="nav-main-link-icon fa fa-plus me-1"></i>
						<span class="nav-main-link-name">Create a community</span>
					</inertia-link>
				</li>
				<li v-if="myCommunities!==null" v-for="(community,cIndex) in myCommunities">
					<inertia-link class="nav-main-link submenu" :href="route('member.community.community-home',{community_name: community.community_name})">
						<img
							class="img-avatar img-avatar20 me-1 user-avatar"
							:src="(community.icon_logo==null ? 'https://ui-avatars.com/api/?size=128&background=000000&color=FFFFFF&rounded=true&font-size=0.7&uppercase=false&length=2&name=c/' : community.icon_logo)"
						/>
						<span class="nav-main-link-name">c/{{community.community_name}}</span>
					</inertia-link>
				</li>
				<li
					key="submenu_1"
					class="nav-main-item"
				>
					<inertia-link
						class="nav-main-link submenu"
						:class="{ active: $page.component=='Member/Community/Community' }"
						:href="$page.url"
					>
						<img
							class="img-avatar img-avatar20 me-1 user-avatar"
							src="https://ui-avatars.com/api/?size=128&background=000000&color=FFFFFF&rounded=true&font-size=0.7&uppercase=false&length=2&name=c/"
						/>
						<span class="nav-main-link-name">All</span>
					</inertia-link>
				</li>
			</ul>
		</li>
	</div>
</template>

<script>
import moment from 'moment'

export default {
	props: {
		user 				: Object,
		sidebarMenus 		: Object,
		myCommunities 		: Object,
		communitiesVisited 	: Object,
	},
	setup(props) {
		const dateToday = () => {
			return moment(String(new Date())).format('YYYY-MM-DD')
		}
		return {
			dateToday,
		}
	},
}
</script>
